module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yt"
  }, [(!_vm.videoShown) ? _c('div', [_c('img', {
    ref: "img",
    staticClass: "thumb",
    attrs: {
      "src": "//img.youtube.com/vi/" + _vm.link.url + "/" + _vm.currentImageResolution + ".jpg"
    },
    on: {
      "click": _vm.changeToYoutubeVideo,
      "load": _vm.testLoadedImage
    }
  }), _c('i', {
    staticClass: "fa fa-play fa-2x"
  })]) : _vm._e(), (_vm.videoShown) ? _c('div', {
    staticClass: "videoWrapper"
  }, [_c('iframe', {
    attrs: {
      "src": "//www.youtube.com/embed/" + _vm.link.url + "?autoplay=1&modestbranding=1&hd=1&autohide=1&color=white",
      "frameborder": "0",
      "allowfullscreen": "allowfullscreen",
      "allow": "autoplay"
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed468390","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupPages/GroupPageLinkYoutube.vue
// module id = 1290
// module chunks = 2